import './EmployeesStep.less';
import * as R from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import {
  propositionSetStaff,
  propositionGoNextStep,
  propositionGoPreviousStep,
  propositionSetHealthStaff,
  propositionSetHealthContractDescription, propositionSetTariffStructure
} from '../../../reduxActions/proposition';
import Checkbox from 'rc-checkbox';
import { FieldTitle } from '../../../uikit/UIKit';
import { BtnNext, EmployeeNumber } from '../components/.';
import { libs } from '@fasstech/spid-front';
import withUser from '../../../withUser';
import { pathEq } from 'ramda';
import getAmendmentInfos from '../../../lib/getAmendmentInfos';
import HealthAdditionalInformations from './employeesStep/HealthAdditionalInformations';
import TakeChargeCheckbox from './employeesStep/TakeChargeCheckbox';
import useEmployeesStep from './employeesStep/useEmployeesStep';
import ObjectiveCategories from './employeesStep/ObjectiveCategories';

const EmployeesStep = ({
  ccn,
  goPreviousStep,
  duplicata,
  userRole,
  amendment,
  selectAuto,
  brokerageBundledCollege,
  userRoleIs,
  staff,
  setStaff,
  goNextStep,
  offerType,
  setTariffStructure,
  tariffStructure,
  resetHealthContractDescription,
  isRelatedContract,
  isProtectionAmendment,
  isHealthAmendment,
  isAmendment
}) => {
  const {
    displayInfo,
    formerColleges,
    collegeIs,
    isSelected,
    colleges,
    buttonDisabled,
    onNext,
    onChange,
    getCount,
    collegesPopup,
    setSelectedCategories,
    totalNumberOfEmployeesErrorMessage,
    numberOfEmployeesV2ErrorMessage,
    takeChargeOfBeneficiaries,
    setTakeChargeOfBeneficiaries,
    tariffStructures,
    tariffStructureIsUniform,
    setTariffStructureIsUniform,
    disabledColleges,
    selectedCategories
  } = useEmployeesStep({
    bundledCollege: userRoleIs('apporteur') ? brokerageBundledCollege : R.pathOr([], [offerType, 'bundledCollege'], ccn),
    amendment,
    staff,
    setStaff,
    goNextStep,
    ccn,
    offerType,
    userRole,
    setTariffStructure,
    tariffStructure,
    resetHealthContractDescription,
    isProtectionAmendment,
    isHealthAmendment,
    isAmendment
  });

  return <>
    <FieldTitle
      text="Collège(s) à couvrir ?"
      onBack={goPreviousStep}
    />

    {R.map(college => {
      return <React.Fragment key={college}>
        {collegeIs(college) && <>
          <div className="employees-step-row">
            <Checkbox
              disabled={(R.includes('NC')(formerColleges) && isProtectionAmendment) || R.includes(college, disabledColleges)}
              checked={isSelected(college) || selectAuto}
              onChange={e => onChange(e, college)}
            />

            <EmployeeNumber
              value={getCount(college)}
              title={libs.collegeLabel(college, ccn, offerType)}
              disabled={R.includes(college, disabledColleges)}
              onChange={e => setSelectedCategories(R.assocPath([college, 'count'], parseInt(e.target.value)))}
            />
          </div>

          <ObjectiveCategories
            college={college}
            collegeIsSelected={isSelected(college)}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
          />
        </>}
      </React.Fragment>;
    })(colleges)}

    {displayInfo && !duplicata && userRole === 'groupe_adhesion' && !isRelatedContract && (
      <div className="employees-step-info">{'L’effectif à couvrir est > ou = à 20 salariés, merci de transmettre le dossier au réseau commercial.'}</div>
    )}

    {userRole === 'reseau_commercial' && !R.isNil(totalNumberOfEmployeesErrorMessage) && (
      <div className="text-red-500 mt-4">{totalNumberOfEmployeesErrorMessage}</div>
    )}

    {!R.isNil(numberOfEmployeesV2ErrorMessage) && (
      <div className="text-red-500 mt-4">{numberOfEmployeesV2ErrorMessage}</div>
    )}

    {collegesPopup}

    {offerType === 'SANTE' && <HealthAdditionalInformations ccn={ccn}/>}

    {offerType === 'SANTE' && R.length(tariffStructures) > 1 && <TakeChargeCheckbox
      takeChargeOfBeneficiaries={takeChargeOfBeneficiaries}
      setTakeChargeOfBeneficiaries={setTakeChargeOfBeneficiaries}
      tariffStructures={tariffStructures}
      tariffStructureIsUniform={tariffStructureIsUniform}
      setTariffStructureIsUniform={setTariffStructureIsUniform}
    />}

    <BtnNext
      disabled={buttonDisabled}
      onClick={onNext}
      title={'Je personnalise mon contrat'}
    />
  </>;
};

export default connect(
  ({ proposition }) => {
    const currentOfferType = R.pathOr('PREVOYANCE', ['data', 'currentOfferType'])(proposition);

    return {
      ccn: R.path(['data', 'ccn'], proposition),
      staff: currentOfferType === 'SANTE' ? R.path(['data', 'health', 'staff'], proposition) : R.path(['data', 'staff'], proposition),
      brokerageBundledCollege: R.pathOr([], ['data', 'ccn', 'brokerageSettings', 'bundledCollege'], proposition),
      duplicata: R.pathOr(false, ['data', 'duplicata'])(proposition),
      userRole: R.propOr('groupe_adhesion', 'userRole')(proposition),
      ...getAmendmentInfos(proposition.data),
      offerType: R.pathOr('PREVOYANCE', ['data', 'currentOfferType'])(proposition),
      tariffStructure: R.path(['data', 'health', 'tariffStructure'], proposition),
      isRelatedContract: pathEq(['data', 'relatedContract', 'checked'], true, proposition)
    };
  },
  dispatch => ({
    setStaff: (categories, value, offerType) => offerType === 'PREVOYANCE' ? dispatch(propositionSetStaff(categories, value)) : dispatch(propositionSetHealthStaff(categories, value)),
    setTariffStructure: (tariffStructure) => dispatch(propositionSetTariffStructure(tariffStructure)),
    resetHealthContractDescription: () => dispatch(propositionSetHealthContractDescription({})),
    goPreviousStep: () => dispatch(propositionGoPreviousStep()),
    goNextStep: () => dispatch(propositionGoNextStep())
  })
)(withUser(EmployeesStep));

